import React from "react";
import './UserRoleService.css';

const UserRoleService=()=>{
    return(
        <div className="userrole-Service-Master">
        <div className="userrole-service">
            {/* <h3>Role Service Map</h3> */}
        </div>
        <div className="userrole-container">
            <div className="userrole-Header">
                <h3>USER/ROLE Service Map</h3>
            </div>
            <div className="userrole-container-body">
                <div className="userrole-form">
                    <label className="userrole-label">Select Role</label>
                    <select className="userrole-select">
                        <option value="" disabled selected>Select</option>
                        <option value="1">Role 1</option>
                        <option value="2">Role 2</option>
                        <option value="3">Role 3</option>
                        <option value="4">Role 4</option>
                    </select>
                </div>

                <div className="userrole-form">
                    <label className="userrole-label">Select User</label>
                    <select className="userrole-select">
                        <option value="" disabled selected>Select</option>
                        <option value="1">User 1</option>
                        <option value="2">User 2</option>
                        <option value="3">User 3</option>
                        <option value="4">User 4</option>
                    </select>
                </div>
             

                <div className="userroleButtons">
                   
                    <button className="btn-userrole">SUBMIT</button>
                </div>

            </div>
        </div>
    </div>
    );
}
export default UserRoleService;